import React from "react";
import { useSelector } from "react-redux";
import { Layout, Typography, Spin, Breadcrumb } from "antd";
import PFheader from "../components/hooks_components/Header";
import { camelCase, compact, get, replace, split } from "lodash";
import { useTranslation } from "react-i18next";
import { ENVIRONMENT } from "../utils/properties";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const { Title, Link } = Typography;
const { Header, Footer, Content } = Layout;

const NoMenuLayout = ({
  haveBreadcrumb = false,
  isCustom = false,
  haveTitle = false,
  haveBack = false,
  backUrl = "",
  name = "",
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const pageIsLoading = useSelector((state) => get(state.loadingDuck, "pageIsLoading", false));
  const section = useSelector((state) => get(state.sectionDuck, "section", { title: "" }));
  const splittedPath = compact(split(location.pathname, "/"));
  const goBack = (link) => () => {
    navigate(link);
  };

  const getSplittedPathTitle = (p, k, length) => {
    if (length === k + 1) {
      return isCustom ? t(section.title) : t(`menuLeft.${camelCase(replace(p, "/", ""))}`);
    } else {
      return (
        <span className="cursor-pointer" onClick={goBack(`/${p}`)}>
          {t(`menuLeft.${camelCase(replace(p, "/", ""))}`)}
        </span>
      );
    }
  };

  return (
    <Layout className="min-h-100vh">
      <Header className="PFheader">
        <PFheader />
      </Header>
      <Layout className="h-100">
        <Breadcrumb
          hidden={!haveBreadcrumb}
          className="PFbreadcrumb"
          separator=">"
          items={[
            {
              title: <a href={ENVIRONMENT.BASE_URL}>Home</a>,
            },
            splittedPath.map((p, k) => ({
              title: getSplittedPathTitle(p, k, splittedPath.length),
              key: `${p}-${k}`, // Combina `p` e `k` per garantire unicità
            })),
          ]}
        />
        <div className="PFtitle" hidden={!haveTitle}>
          <div className="parallelogram">
            <Title level={5}>
              {haveBack ? (
                <>
                  <Link className="PFwhite" onClick={goBack(backUrl)}>
                    <ArrowLeftOutlined />
                  </Link>{" "}
                  |{" "}
                </>
              ) : (
                ""
              )}
              {!isCustom ? t(name) : t(section.title)}
            </Title>
          </div>
        </div>
        <Content>
          <div className="PFcontent p-relative">
            <Outlet />
            {pageIsLoading ? (
              <div className="container-spinner-positioning">
                <Spin spinning={pageIsLoading} className="spinner-positioning" />
              </div>
            ) : (
              ""
            )}
          </div>
        </Content>
      </Layout>
      <Footer className="PFfooter" />
    </Layout>
  );
};

export default NoMenuLayout;
